import { useLazyQuery, useQuery } from "@apollo/client";
import { ROUNDS } from "../rounds.queries";
import {
  RoundsQuery,
  RoundsQueryVariables,
} from "../../../__generated__/RoundsQuery";

export const useRounds = (variables: RoundsQueryVariables) => {
  return useQuery<RoundsQuery, RoundsQueryVariables>(ROUNDS, {
    variables,
  });
};

export const useLazyRounds = () => {
  return useLazyQuery<RoundsQuery, RoundsQueryVariables>(ROUNDS);
};
